import React, { useCallback, useEffect, useRef, useState } from 'react';
import style from './Chat.module.css';
import HeadSub from "../../../components/comm/HeadSub";

import CircularProgress from '@mui/material/CircularProgress';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import greatLottie from "../../../assets/lottiefiles/great.lottie";

import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import NutritionChatCautionBox from '../../../components/box/NutritionChatCautionBox'

const NutritionChat = () => {

    const userInfo = JSON.parse(sessionStorage.getItem("loginUser"));

    const [bmtInfo, setBmtInfo ] = useState({
        isTakeDrug : false ,
        transType : ""
    })

    //
    const [isLoadingMessageVisible, setIsLoadingMessageVisible] = useState(false);
    const [loadingIndex, setLoadingIndex] = useState(0);
    const loadingPhrases = ["답변을 생각하고 있어요", "잠시만 기다려 주세요", "거의 다 됐어요"];

    const inputRef = useRef(null);

    const [isInputFocused, setIsInputFocused] = useState(false);
    const isAndroid = /Android/i.test(navigator.userAgent);

    //채팅 대기열 확인
    const [requestUid, setRequestUid] = useState(null);
    const [queuePosition, setQueuePosition] = useState(null);
    
    useEffect(() => {
        const handleFocus = () => {
            setTimeout(() => {
                inputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 300);
        };

        inputRef.current?.addEventListener('focus', handleFocus);
        return () => inputRef.current?.removeEventListener('focus', handleFocus);
    }, []);

    useEffect(() => {
        if (!isLoadingMessageVisible) return;

        const interval = setInterval(() => {
            setLoadingIndex((prev) => (prev + 1) % loadingPhrases.length);
        }, 1500);

        return () => clearInterval(interval);
    }, [isLoadingMessageVisible]);

    //추천질문 on/off
    const [Toggle, setToggle] = useState(false);
    const onToggle = () => setToggle(!Toggle);

    const [txtNum, setTxtNum] = useState(1);
    
    //주의사항 목록
    const cautionList = 
        {
            1 : {
                title : '음식 조리 및 섭취 장소 주의사항',
                txtNum : 1
            },
            2 : {
                title : '면역억제제 섭취 시 주의사항',
                txtNum : 2
            },
        }
    ;

    // 바텀 시트
    const [open, setOpen] = useState(false);

    function onDismiss() {
        setOpen(false);
    }


    //스크롤
    const chatEndRef = useRef(null);

    //입력 텍스트
    const [textQuestion, setTextQuestion] = useState("");

    //채팅
    const [chatList, setChatList] = useState([]);

    const isInit = useRef(false);

    useEffect(() => {
        if (isInit.current) return;
        
        isInit.current = true;
        setChatList((prev) => [
            ...prev, 
            { type: 'date', dateStr: getCurrentDateStr(), date: getCurrentDate() },
            {
                type: 'bot',
                text: "안녕하세요\n영양 상담을 도와드릴 챗봇입니다!\n\n상담을 시작하기 전, 더 건강하고 안전한 식사와 약물 복용을 위해 아래 내용을 꼭 확인해 주세요.\n\n📌 음식 조리 및 섭취 장소 주의사항\n📌 면역억제제 복용 시 주의사항\n\n채팅 입력창 바로 위에 위치한 버튼을 눌러 확인할 수 있습니다" ,
                source: 'api',
                date: getCurrentDate(),
                chatTime: getCurrentTime()
            }
        ]);
    },[])

    //전송중 체크
    const isSendingRef = useRef(false);
    
    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [chatList]);
    //추천질문 클릭
    // const handleClickRecommendQuestion = (selectQuestion, selectAnswer) => {
    //     // callChatBotApi(selectQuestion);

    //     setChatList((prev) => [
    //         ...prev, 
    //         {
    //             type: 'user',
    //             text: selectQuestion,
    //             date: getCurrentDate(),
    //             chatTime: getCurrentTime()
    //         },
    //         {
    //             type: 'bot',
    //             text: selectAnswer ,
    //             date: getCurrentDate(),
    //             chatTime: getCurrentTime()
    //         }
    //     ]);
    // }

    //주의사항 안내 클릭
    const handleClickReCaution = (selectTxtNum) => {
        setTxtNum(selectTxtNum);
        setOpen(true);
    }


    //좋아요 / 싫어요 컨트롤 
    const handleClickRecomBtn = (gbn, id, questionTime) => {

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading: true,
        }

        const params = {
            usrInfoId : userInfo.usrInfoId, //사용자 정보 아이디
            questionTime : questionTime, //환자가 질문을 입력한 시간
            patientFeedback : gbn, //환자가 입력한 피드백. 1:좋아 0:싫어
        }

        const feedbackUrl = '/chatbot/feedback';

        axiosApi.post(feedbackUrl, params, reqOptions)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                console.log(res.data.result.answer);
            } else {
                alert(res.data.resultMessage);
                isSendingRef.current = false;
            }
        })
        .catch(err => {
            console.error("API 오류:", err);
        })

        if (gbn === 1) {
            const newKey = Date.now();  // 새로운 키 생성

            setChatList(prev =>
                prev.map(chat =>
                    chat.id === id
                        ? {
                            ...chat,
                            recommendChecked: gbn,
                            showLottie: true,
                            lottieKey: newKey // 새로운 키 추가
                        }
                        : chat
                )
            );

            setTimeout(() => {
                setChatList(prev =>
                    prev.map(chat =>
                        chat.id === id
                            ? { ...chat, showLottie: false }
                            : chat
                    )
                );
            }, 2000);

        } else {
            setChatList(prev =>
                prev.map(chat =>
                    chat.id === id
                        ? { ...chat, recommendChecked: gbn }
                        : chat
                )
            );
        }

    }
    
    const onKeyDownHandle = (e) => {
        if (e.keyCode === 13 && !isSendingRef.current) {
            callChatBotApi(e.target.value);
        }
    }

    useEffect(()=> {
        
        const jToken = localStorage.getItem('jToken');

        const url = '/chatbot/retrieveUsrBmtInfo';

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading: true,
        }

        axiosApi.post(url, {}, reqOptions)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const isTakeDrug = res.data.result.bmtInfo.isTakeDrug;
                const transType = res.data.result.bmtInfo.transType;
                setBmtInfo({
                    ...bmtInfo,
                    isTakeDrug : isTakeDrug,
                    transType : transType ? transType : ""
                });
            } else {
                alert(res.data.resultMessage);
            }
        }).catch(err => {
            console.error(err);
        })
    },[])

    const callChatBotApi = useCallback(async (question) => {
        if (!question.trim() || isSendingRef.current) return;

        isSendingRef.current = true;

        const nowDate = getCurrentDateStr();

        setChatList(prev => {
            const lastDateInChat = [...prev].reverse().find(item => item.type === 'date')?.dateStr;
            const newChatList = [...prev];

            // 날짜 변경되었으면 날짜 라인 추가
            if (nowDate !== lastDateInChat) {
                newChatList.push({ type: 'date', dateStr: nowDate, date: getCurrentDate() });
            }

            newChatList.push({ type: 'user', text: question, date: getCurrentDate(), chatTime: getCurrentTime() });
            return newChatList;
        });
        
        const apiUrl = '/chatbot/question';

        setChatList((prev) => [
            ...prev, 
            {
                type: 'bot',
                text: '',
                source: 'waiting',
                date: getCurrentDate(),
                chatTime: getCurrentTime()
            }
        ]);

        setIsLoadingMessageVisible(true);


        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading: true,
        }

        const requestUid = crypto.randomUUID();

        setRequestUid(requestUid);

        const params = {
            usrInfoId : userInfo.usrInfoId, //사용자 정보 아이디
            transplantType : bmtInfo.transType, //조혈모세포 이식 종류
            isTakeDrug : bmtInfo.isTakeDrug, //면역억제제 복용 여부
            question : question,
            requestUid : requestUid
        }

        await axiosApi.post(apiUrl, params, reqOptions)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
        
                setChatList(prev => {
                    const updated = prev.filter(chat => chat.source !== 'waiting');
                    const newItems = [];
                    
                    const botReply = res.data.result.answer;
                    const questionTime = res.data.result.questionTime;

                
                    if (botReply) {
                        newItems.push({
                            type: 'bot',
                            text: botReply,
                            source: 'api',
                            date: getCurrentDate(),
                            chatTime: getCurrentTime(),
                            id: Date.now(), 
                            questionTime : questionTime,
                            recommendChecked: null
                        });
                    } else {
                        newItems.push({
                            type: 'bot',
                            text: "답변을 찾을 수 없습니다.",
                            source: 'api',
                            date: getCurrentDate(),
                            chatTime: getCurrentTime()
                        });
                    }
                
                    return [...updated, ...newItems];
                });

            } else {
                // alert(res.data.resultMessage);
                setChatList((prev) => {
                    const updated = prev.filter(chat => chat.source !== 'waiting');
                    const newItems = [
                        { 
                            type: 'bot',
                            text: "앗! 일시적인 오류로 답변을 불러오지 못했어요. 다시 질문해주세요.", 
                            source: 'api', 
                            date: getCurrentDate(), 
                            chatTime: getCurrentTime() 
                        },
                    ];

                    return [...updated, ...newItems]
                });
                isSendingRef.current = false;
            }
        })
        .catch(err => {
            console.error("API 오류:", err);
            setChatList((prev) => {
                const updated = prev.filter(chat => chat.source !== 'waiting');
                const newItems = [
                    { 
                        type: 'bot',
                        text: "앗! 일시적인 오류로 답변을 불러오지 못했어요. 다시 질문해주세요.", 
                        source: 'api', 
                        date: getCurrentDate(), 
                        chatTime: getCurrentTime() 
                    },
                ];

                return [...updated, ...newItems]
            });
        }).finally(() => {
            isSendingRef.current = false;
            setIsLoadingMessageVisible(false);
            setLoadingIndex(0);
            setQueuePosition(null); 
            setRequestUid(null);
        });

        setTextQuestion("");
    }, [bmtInfo]);

    const checkMyQueuePosition = async (id) => {
        try {
            const res = await axiosApi.get(`/chatbot/chat/status/${id}`,{noLoading: true});
            const position = res.data.position;
    
            console.log("대기열         : ",position)

            if (position <= 0) {
                setQueuePosition(null);
                setRequestUid(null);
                return;
            }
    
            setQueuePosition(position); 
        } catch (err) {
            console.error("대기 순번 확인 실패", err);
        }
    };

    useEffect(() => {
        if (!requestUid) return;
        
        setTimeout(() => {
            checkMyQueuePosition(requestUid)
        }, 300);

        
        const interval = setInterval(() => {
            checkMyQueuePosition(requestUid);
        }, 1000);
    
        return () => clearInterval(interval);
    }, [requestUid]);


    //날짜 관련 함수
    const getCurrentDateStr = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); 
        const day = String(now.getDate()).padStart(2, "0"); 
        
        const dayNames = ["일", "월", "화", "수", "목", "금", "토"]; // 요일 배열
        const dayOfWeek = dayNames[now.getDay()]; // getDay()는 0(일요일) ~ 6(토요일)
        
        return `${year}.${month}.${day}(${dayOfWeek})`;
    };
    
    //날짜 관련 함수
    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); 
        const day = String(now.getDate()).padStart(2, "0"); 
        
        
        return `${year}${month}${day}`;
    };
    
    //날짜 관련 함수
    const getCurrentTime = () => {
        const now = new Date();
        return now.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    };

    const ChatListComp = ({chatList}) => {
        return (
            chatList.map((chat, index) => {
                if (chat.type === 'date') {
                    return (
                        <div key={index} className={style['hr-line']}>
                            <span>{chat.dateStr}</span>
                        </div>
                    );
                }

                return (
                    <React.Fragment key={index}>
                    {chat.type === 'user' ? (
                        <div className={style['user-talk-box']}>
                            <span className={style['date-txt']}>{chat.chatTime}</span>
                            <p>{chat.text}</p>
                        </div>
                    ) : (
                        <div className={style['ai-talk-box']}>
                            <strong className={style['ai-avatar']}>AI 영양사</strong>
                            {chat.source !== 'waiting' && (
                                <div className={style['ai-box']}>
                                    <div className={style['text-box']}>
                                        <div className={style['p-group']}>
                                            {/* <p>
                                                <span>안녕하세요. 김성모님,</span> 
                                                <span>매운 라면이 드시고 싶으시군요!</span>
                                            </p>  */}
                                            <p dangerouslySetInnerHTML={{ __html: chat.text }}></p>
                                        </div>
                                    <span className={style['date-txt']}>{chat.chatTime}</span> 
                                    </div>

                                    {/* 추천 버튼 클리시 */}
                                    <div className={style['recommend-box']}>

                                        {chat.recommendChecked === null && (
                                            <>
                                                <span>위 답변이 도움이 되었나요?</span>
                                                <button className={style['recomm-up']}
                                                    onClick={() => handleClickRecomBtn(1, chat.id, chat.questionTime)}
                                                ></button>
                                                <button className={style['recomm-down']}
                                                    onClick={() => handleClickRecomBtn(0, chat.id, chat.questionTime)}
                                                ></button>
                                            </>
                                        )}
                                        {chat.recommendChecked === 1 && (
                                            <>
                                                <button className={style['recomm-up']}></button>

                                                {chat.showLottie &&
                                                    <div className='lottie-box'>
                                                    <DotLottieReact
                                                        key={chat.lottieKey}
                                                        src={greatLottie}
                                                        autoplay
                                                        loop={false}
                                                        style={{width: '50%'}}
                                                    />
                                                    </div> 
                                                }
                                            </>
                                        )}
                                        {chat.recommendChecked === 2 && (
                                            <button className={style['recomm-down']}></button>
                                        )}

                                    </div>
                                </div>
                            )}

                            {chat.source === 'waiting' && (
                                // <div className={style['loading-txt-box']}>
                                //     <p className={style['loading-txt']}>답변을 생각하고 있어요 </p>
                                //     <CircularProgress size="15px" />
                                // </div>
                                <div className={style['loading-txt-box']}>
                                    {queuePosition && queuePosition > 0 &&
                                        <p className={style['loading-txt']}>{loadingPhrases[loadingIndex]} <br/>대기순서 : {queuePosition} 번째</p>
                                    }
                                    {!(queuePosition > 0) &&
                                        <p className={style['loading-txt']}>{loadingPhrases[loadingIndex]}</p>
                                    }
                                    <CircularProgress size="15px" />
                                </div>
                            )}
                        </div>
                    )}
                    </React.Fragment>
                );
            })
        )
    }

    useEffect(() => {
        const handler = (e) => {
            const link = e.target.closest(".external-link");
            if (!link) return;

            e.preventDefault();
            const url = link.dataset.url;
            openExternalUrl(url);
        };

        document.addEventListener("click", handler);
        return () => document.removeEventListener("click", handler);
    }, []);

    // IOS 이슈 새창 - 유틸 함수 추가
    const openExternalUrl = (url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: url
            }));
        } else {
            window.open(url, '_blank');
        }
    };

    return (
        <>
            <HeadSub title="영양 상담"/>

             <div id="sub-content">
                <div className="inner-wrap" data-pad-type="b">

                    <div className={style['notice-box']}>
                          <strong>영양 상담 이용 시 주의 사항</strong>
                          <ul>
                                <li>영양 상담은 챗봇을 통해 진행됩니다.</li>
                                <li>챗봇의 답변은 전문가의 의학적 판단이나 진료 행위를 대신할 수 없습니다. </li>
                                <li>영영 상담은 음식물 섭취와 관련한 질문/답변만 가능합니다.</li>
                                <li>개인정보는 입력하지 않도록 주의해주세요.</li>    
                          </ul>
                    </div>                     
                    
                    <ChatListComp chatList={chatList}/>
                    <div ref={chatEndRef} /> 
                </div>


                {/* 추천 질문 */}
                <div className={style['re-question-box']}>
                    <button className={style['question-btn']} data-status={Toggle? "on": "off"} onClick={onToggle}>
                        <span>주의 사항</span>
                    </button>
                    <div className={style['question-lists']}>
                        <ul>
                            {Object.entries(cautionList).map(([key, { title, txtNum }]) => (
                                // <li key={key} onClick={() => handleClickRecommendQuestion(question, answer)}>
                                //     {question}
                                // </li>
                                <li key={key} onClick={() => handleClickReCaution(txtNum)}>
                                    {title}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>            

                <div className={style["bottom-fixed-box"]}
                    style={{
                        bottom: (isInputFocused && isAndroid) ? 'env(keyboard-inset-height, 0px)' : '0px',
                        paddingBottom: (isInputFocused && isAndroid) ? 'env(safe-area-inset-bottom, 0px)' : '0px'
                    }}>
                    <div className={style["in-box"]}>
                        <div className={style["input-box"]}>
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="질문을 입력해주세요."
                                value={textQuestion}
                                onChange={(e) => setTextQuestion(e.target.value)}
                                onKeyDown={onKeyDownHandle}
                                onFocus={() => {
                                    setIsInputFocused(true);
                                    setTimeout(() => {
                                        inputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                    }, 300);
                                }}
                                onBlur={() => {
                                    setIsInputFocused(false);
                                }}
                                disabled={isSendingRef.current}
                            />
                            <button className={style["push-btn"]}
                                disabled={!textQuestion.trim() || isSendingRef.current}
                                onClick={() => callChatBotApi(textQuestion)}
                            ></button>
                        </div>
                    </div>
                </div>
                <BottomSheet
                    scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                    expandOnContentDrag={false} // 내용 드래그로 확장 방지
                    open={open}
                    onDismiss={onDismiss}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking={false}
                        >
                        <NutritionChatCautionBox onClose={onDismiss} txtNum={txtNum}/>
                </BottomSheet>

            </div>
            
        </>
    )
}

export default NutritionChat;